export const LINE_ITEMS_ID_FORM_PREFIX = 'lineItems';
export const getLineItemFieldByIndex = (index, fieldName) => `${LINE_ITEMS_ID_FORM_PREFIX}.${index}.${fieldName}`;
export const getLineItemFormErrors = (errors) => {
    if (!errors) {
        return ({
            errorLineItemFieldsCount: 0,
            errorLineItemRefs: [],
        });
    }
    // loop over object
    const keys = Object.keys(errors).filter((key) => key !== '_errors');
    if (!keys.length) {
        return ({
            errorLineItemFieldsCount: 0,
            errorLineItemRefs: [],
        });
    }
    const errorLineItemRefs = [];
    let errorLineItemFieldsCount = 0;
    keys.forEach((key) => {
        const fields = errors[key];
        const fieldKeys = Object.keys(fields).filter((field) => fields[field] !== null);
        const validFields = fieldKeys.filter((field) => field !== '_errors');
        errorLineItemFieldsCount += validFields.length;
        errorLineItemRefs.push(...validFields.map((field) => getLineItemFieldByIndex(Number(key), field)));
    });
    return ({
        errorLineItemFieldsCount,
        errorLineItemRefs,
    });
};
/**
 * This function takes a string `sku` as input and returns a sanitized version of the string with line breaks removed and any leading or trailing whitespace characters trimmed.
 * Example Usage:
 * sanitizeSKU(" ABC-123 "); // returns "ABC-123"
 * sanitizeSKU("ABC-123"); // returns "ABC-123"
 * sanitizeSKU("ABC\n123"); // returns "ABC123"
 * sanitizeSKU("\nABC-123\n"); // returns "ABC-123"
 * @param sku - the SKU to sanitize
 */
export function sanitizeSKU(sku) {
    var _a;
    return (_a = sku === null || sku === void 0 ? void 0 : sku.replace(/[\r\n]+/g, '').trim()) !== null && _a !== void 0 ? _a : '';
}
//# sourceMappingURL=OcrUtils.js.map